import { z } from 'zod';

import { collapseWhitespace } from '@vestigas/utils';

import { SUPPLIER_IDENTIFIER_CHECK_OUTCOME } from '../constants';
import {
  zodCompanyRefSchema,
  zodPriorRejectionRefSchema,
} from '../validations';

/**
 * Zod schema for the GET /suppliers/requests/check query parameters.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Suppliers/operation/check_by_identifier_suppliers_requests_check_get
 */
export const zodSupplierIdentifierCheckParamsSchema = z.object({
  gln: z.string().transform(collapseWhitespace).nullish(),
  hra: z.string().max(64).transform(collapseWhitespace).nullish(),
  // Each register number is qualified by its own register court, and the two may
  // differ. A court narrows the match; omitting one never widens it, so an
  // unqualified register number can match a namesake at another court.
  hraRegisterCourt: z.string().max(80).transform(collapseWhitespace).nullish(),
  hrb: z.string().max(64).transform(collapseWhitespace).nullish(),
  recipientCompanyId: z.uuid(),
  registerCourt: z.string().max(80).transform(collapseWhitespace).nullish(),
  vatId: z.string().max(64).transform(collapseWhitespace).nullish(),
});

/**
 * Zod schema for the GET /suppliers/requests/check response
 * (IdentifierExistenceCheckResponse).
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Suppliers/operation/check_by_identifier_suppliers_requests_check_get
 */
export const zodSupplierIdentifierCheckResponseSchema = z.object({
  existingRequestId: z.uuid().nullish(),
  matchedCompany: zodCompanyRefSchema.nullish(),
  outcome: z.enum(SUPPLIER_IDENTIFIER_CHECK_OUTCOME),
  priorRejection: zodPriorRejectionRefSchema.nullish(),
});
